<template>
  <div class="reset-page">
    <div class="alert" role="alert" id="snackbar_reset_page">{{ msg }}</div>
    <div class="form">
      <h4 class="title">Set a new password</h4>
      <form class="reset-form" @submit.prevent="Reset">
        <div class="password-field">
          <input id="password1" type="password" placeholder="New password" v-model="password">
          <span class="eye-toggle" @click="showPswd"><i class="fa fa-eye"></i></span>
        </div>
        <div class="password-field">
          <input id="confirm_password" type="password" placeholder="Confirm password" v-model="confirm_password">
        </div>
        <button type="button" class="btn-sm btn-info" @click="Reset" :disabled="busy">
          {{ busy ? 'Saving...' : 'Reset password' }}
        </button>
        <p class="message"><router-link to="/">Back to login</router-link></p>
      </form>
    </div>
  </div>
</template>

<script>
import http from '../../services/http'
export default {
  name: 'PassReset',

  data() {
    return {
      password: '',
      confirm_password: '',
      msg: '',
      busy: false
    }
  },

  methods: {
    showPswd() {
      const x = document.getElementById('password1')
      x.type = x.type === 'password' ? 'text' : 'password'
    },

    Reset() {
      if (!this.password || this.password.length < 6) {
        this.showMsg('Your new password must be at least 6 characters.')
        return
      }
      if (this.password !== this.confirm_password) {
        this.showMsg('The passwords do not match.')
        return
      }

      this.busy = true
      http.post('/api/password/reset', {
        token: this.$route.params.key,
        password: this.password,
        password_confirmation: this.confirm_password
      })
        .then((res) => {
          this.busy = false
          this.showMsg(res.data.message)
          setTimeout(() => { this.$router.push('/') }, 2500)
        })
        .catch((error) => {
          this.busy = false
          const m = (error.response && error.response.data && error.response.data.message)
            || 'Could not reset your password. Please request a new reset link.'
          this.showMsg(m)
        })
    },

    showMsg(m) {
      this.msg = m
      const x = document.getElementById('snackbar_reset_page')
      if (!x) return
      x.className = 'show'
      setTimeout(() => { x.className = x.className.replace('show', '') }, 6000)
    }
  }
}
</script>

<style scoped>
.reset-page {
  width: 100%;
  max-width: 400px;
  padding: 0 16px;
  margin: auto;
  display: flex;
  align-items: center;
  min-height: 100vh;
}

.form {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 40px 36px;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
  color: var(--text);
}

.title {
  color: var(--text);
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px;
}

.form input {
  font-family: var(--font-sans);
  outline: 0;
  background: var(--bg-base);
  color: var(--text);
  width: 100%;
  border: 1px solid var(--border);
  margin: 0;
  padding: 12px 14px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: var(--radius-sm);
}

.form input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.form input::placeholder {
  color: var(--text-faint);
}

.password-field {
  position: relative;
  margin: 0 0 15px;
}

.password-field input {
  padding-right: 42px;
}

.eye-toggle {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: var(--text-muted);
  cursor: pointer;
  z-index: 2;
  line-height: 1;
}

.eye-toggle:hover {
  color: var(--accent);
}

.reset-form button {
  width: 100%;
  padding: 12px;
  margin-top: 4px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--accent-contrast);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.reset-form button:hover:not(:disabled) {
  background: var(--accent-hover);
}

.reset-form button:disabled {
  opacity: 0.6;
  cursor: default;
}

.message {
  margin: 18px 0 0;
  color: var(--text-muted);
  font-size: 12px;
}

.message a {
  color: var(--accent);
  text-decoration: none;
}

.message a:hover {
  text-decoration: underline;
}

#snackbar_reset_page {
  visibility: hidden;
  min-width: 280px;
  max-width: 460px;
  margin-left: -230px;
  text-align: center;
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--accent);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow);
  padding: 12px 16px;
  position: fixed;
  z-index: 1100;
  left: 50%;
  top: 10px;
  font-size: 14px;
}

#snackbar_reset_page.show {
  visibility: visible;
}
</style>
